import React from "react";
import { Field, reduxForm } from "redux-form";

import Button from "components/atoms/button";
import FormFieldset from "components/molecules/formFieldset";
import FormCol from "components/molecules/formCol";
import FormTextField from "components/molecules/formTextField";
import FormTextArea from "components/molecules/formTextArea";
import FormActions from "components/molecules/formActions";

import validation from "./validation";

class ContactForm extends React.Component {
  render() {
    const { handleSubmit, pristine, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <FormFieldset>
          <FormCol first="true">
            <Field
              name="name"
              type="text"
              component={FormTextField}
              label="Nombre"
            />
            <Field
              name="lastname"
              type="text"
              component={FormTextField}
              label="Apellido"
            />
            <Field
              name="telephone"
              type="text"
              component={FormTextField}
              label="Teléfono"
            />
            <Field
              name="cellphone"
              type="text"
              component={FormTextField}
              label="Celular"
            />
            <Field
              name="email"
              type="email"
              component={FormTextField}
              label="Correo electrónico"
            />
          </FormCol>
          <FormCol last="true">
            <Field
              name="message"
              component={FormTextArea}
              label="Tu mensaje"
              size="big"
            />
          </FormCol>
        </FormFieldset>
        <FormActions>
          <Button
            disabled={pristine || submitting}
            buttonText="Enviar consulta"
            type="submit"
          />
        </FormActions>
      </form>
    );
  }
}

export default reduxForm({
  form: "contact",
  validate: validation,
})(ContactForm);
